var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wk-drag-button",style:({
    top: _vm.top + 'px',
    left: _vm.left + 'px',
    transition: _vm.transitionStyle
  }),on:{"touchstart":_vm.handleTouchStart,"touchmove":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleTouchMove.apply(null, arguments)},"touchend":_vm.handleTouchEnd,"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }